import { convertToCoverage } from '@/models/search-filter';

import {
  getSearchPropositions,
  mergeData,
  getCoverageData,
  addCoverage,
  getCoverageGeolocations,
  removeCoverage
} from './services';

const actions = {
  async addCoverage({ commit }, searchItem) {
    try {
      const coverage = convertToCoverage(searchItem);
      const result = await addCoverage(coverage);

      const coverageArrayWithGeolocation = await getCoverageGeolocations([
        result.data
      ]);

      commit('addCoverageItem', coverageArrayWithGeolocation[0]);

      return result.status;
    } catch (error) {
      console.error(error);

      if (error.response) return error.response.status;
      else return -1;
    }
  },

  async deleteCoverage({ commit }, coverageId) {
    await removeCoverage(coverageId);
    commit('removeCoverageItem', coverageId);

    return true;
  },

  async fetchCoverages({ commit }) {
    commit('setLoadingCoverage', true);

    const result = await getCoverageData();

    if (result) {
      result.data.results = await getCoverageGeolocations(result.data.results);
    }

    commit('setCoverageData', result.data);
    commit('setLoadingCoverage', false);
  },

  async fetchSearch(
    { commit, state },
    { rootFilter, merge, skipBoundingBoxAlign }
  ) {
    // The page comes from rootFilter only. o-search seeds it from ?page= once
    // on mount; re-reading the live route here would let the address bar and
    // the state drift apart.
    const searchObject = convertToCoverage(rootFilter);

    commit('setLoading', true);

    try {
      const response = await getSearchPropositions(searchObject);

      if (response) {
        if (state.data && searchObject.fromMapInteraction && !merge) {
          commit('setPoints', response.data.points);
          dispatchMapEvents(
            searchObject,
            response.data,
            searchObject.fromMapInteraction && state.data
          );
        } else if (merge) {
          const mergedData = mergeData(state.data, response.data);
          commit('setData', mergedData);
        } else {
          commit('setData', response.data);
          dispatchMapEvents(
            searchObject,
            response.data,
            skipBoundingBoxAlign ? true : false
          );
        }
      }
    } catch (error) {
      console.error(error);

      if (merge) {
        // Leave the list the user is reading intact and let the caller stop
        // auto-loading; clearing it here would unmount the results wrapper,
        // and not clearing it would leave the scroll sentinel in view to
        // retry the same page forever.
        commit('setLoading', false);
        throw error;
      }

      commit('setData', {});
    }

    commit('setLoading', false);
  },

  async resetFilter({ commit }, type) {
    commit('resetFilter', type);
  }
};

function dispatchMapEvents(searchObject, resultData, skipBoundingBoxAlign) {
  const markerPointsEvent = new CustomEvent('markerPoints', {
    detail: resultData.points
  });

  document.dispatchEvent(markerPointsEvent);

  if (skipBoundingBoxAlign) {
    return;
  }

  if (searchObject.map) {
    document.dispatchEvent(
      new CustomEvent('boundingBox', {
        detail: searchObject.map.bounds
      })
    );
  } else if (resultData.bbox) {
    document.dispatchEvent(
      new CustomEvent('boundingBox', {
        detail: resultData.bbox
      })
    );
  } else if (searchObject.searchArea && searchObject.searchArea.bounds) {
    document.dispatchEvent(
      new CustomEvent('boundingBox', {
        detail: searchObject.searchArea.bounds
      })
    );
  }
}

export default actions;
